import React, { useEffect, useState } from 'react'
import { Button, Input, Tabs } from 'antd'
import { CiSearch } from 'react-icons/ci'
import { useDispatch, useSelector } from 'react-redux'

import useDebounce from '../../../hooks/useDebounce'
import {
  addPlayerToDraft,
  getAllPlayers,
  getDraftCounter,
  getDraftQueue,
  getDraftRound,
  setDraftTab,
  setPage,
  setPosition,
  setSearch,
} from '../../../redux/actions/draftAction'

import DraftPool from './DraftPool'
import DraftQueue from './DraftQueue'
import TeamRosters from './TeamRosters'

import { io } from 'socket.io-client'
import { base_url } from '../../../config/constants'
import { getRemainingSeconds } from '../../../config/helperFunctions'
import { getLeagueDetails } from '../../../redux'

const TableComponent = ({ tableScroll }) => {
  const { position, page, limit, search, onTheClock, draftCounter, allPlayers, activeTab } =
    useSelector((state) => state.draft)
  const USER = useSelector((state) => state.user)
  const [loading, setLoading] = useState(false)
  const socket = io(base_url)

  const dispatch = useDispatch()

  useEffect(() => {
    if (localStorage.getItem('token')) {
      socket.on('counter', (data) => {
        console.log('SOCKET==================>', data)
        getDraftCounter()
        getLeagueDetails()
        getAllPlayers({
          position: position,
          search: search,
          limit: limit,
          page: page,
        })
        getDraftRound()

        if (activeTab == 2) getDraftQueue()
      })
    }
    console.log('===>', draftCounter?.time)
  }, [localStorage.getItem('token')])

  const items = [
    {
      key: '1',
      label: 'Draft Pool',
      children: <DraftPool tableScroll={tableScroll} />,
    },
    {
      key: '2',
      label: 'Draft Queue',
      children: <DraftQueue tableScroll={tableScroll} />,
    },
    {
      key: '3',
      label: 'Team Rosters',
      children: <TeamRosters tableScroll={tableScroll} />,
    },
  ]

  const _handleSearch = useDebounce((value) => {
    getAllPlayers({
      search: value,
      position,
      limit,
      page,
    })
  }, 1000)

  const handleSearch = (value) => {
    setSearch(value)
    _handleSearch(value)
  }

  const handleAutoDraft = async () => {
    setLoading(true)
    const draftQueue = await getDraftQueue()
    const playerId =
      draftQueue?.length > 0 ? draftQueue[0]?.player?._id : allPlayers?.players?.[0]?._id

    await addPlayerToDraft({
      playerId: playerId,
      position: draftCounter?.position,
      round: draftCounter?.round,
      remainingTime: getRemainingSeconds(draftCounter?.time),
      teamId: onTheClock?.team?._id, // will be removed after testing
    })
    setLoading(false)
  }

  return (
    <div className='table_com_box'>
      {
        <div className='pro_table_header'>
          <div className='pro_button_box'>
            {['ALL', 'LW', 'RW', 'C', 'D', 'G']?.map((v, i) => {
              return (
                <Button
                  key={i}
                  type='primary'
                  className={`${position === v ? 'active' : ''}`}
                  onClick={() => {
                    dispatch(setPosition(v))
                    dispatch(setPage(1))
                  }}
                >
                  {v}
                </Button>
              )
            })}
          </div>
          <div className='pro_search_input_box'>
            <Button
              loading={loading}
              disabled={
                // false
                !(onTheClock?.team?._id === USER?.userDetails?.team?._id)
              }
              type='primary'
              onClick={handleAutoDraft}
            >
              AUTODRAFT
            </Button>
            <Input
              onChange={(e) => {
                dispatch(setSearch(e.target.value))
                handleSearch(e.target.value)
                page !== 1 && dispatch(setPage(1))
              }}
              allowClear
              placeholder='Search Player'
              suffix={<CiSearch color='var(--primary)' />}
            />
          </div>
        </div>
      }
      <div className='table_container'>
        <Tabs
          defaultActiveKey='1'
          items={items}
          className='tabs'
          onChange={(v) => dispatch(setDraftTab(v))}
        />
      </div>
    </div>
  )
}

export default TableComponent
